import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslatedToastrService, ValidationHandlerService, LanguageSaveModel, LanguageListModel, ModalBaseComponent } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { CoreService, ImportFileSaveModel, LanguageEditModel } from 'src/app/services/api-services';
import { DataTableRequest, FileResponse } from '../../../../../../Vestra.shared/src/lib/services/api-services';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
    selector: 'app-language-edit',
    templateUrl: './language-edit.component.html',
    styleUrls: ['./language-edit.component.scss'],
})
export class LanguageEditComponent extends ModalBaseComponent {
    showModal: boolean = true;

    constructor(public bsModalRef: BsModalRef, private translatedToastrService: TranslatedToastrService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, private coreService: CoreService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    //input properties
    public title: string;
    public item: LanguageListModel;

    //class properties
    private image: File;
    public imageName: string = '';

    private importFile: File;
    public fileName: string = '';

    private getFormGroup(): FormGroup {
        return new FormGroup({
            name: new FormControl('', [Validators.required]),
            shortCode: new FormControl('', [Validators.required]),
            code: new FormControl('', [Validators.required]),
            isDefault: new FormControl(false),
        });
    }
    public form: FormGroup = this.getFormGroup();

    public init() {
        this.form = this.getFormGroup();

        if (this.item) {
            this.form.patchValue(this.item);
            if (this.item.flagImageUrl) {
                this.setImgSrc('selected-image', this.item.flagImageUrl);
            }
        } else {
            this.clearSelectedImage();
            this.clearImageFileInput();
        }
    }

    public ngAfterViewInit() {
        this.init();
    }

    public onFileSelected(event: any): void {
        const fileInput = event.target as HTMLInputElement;

        if (fileInput.files && fileInput.files.length > 0) {
            this.image = fileInput.files[0];
            if (!this.isImageFileExtensionGood(this.image)) {
                this.onClearImage();
                this.translatedToastrService.warning('common.image_is_required', 'common.warning');
                return;
            }
            var file = fileInput.files[0];
            this.imageName = fileInput.files[0].name;
            var reader = new FileReader();
            reader.onloadend = () => {
                this.setImgSrc('selected-image', <any>reader.result);
            };
            reader.readAsDataURL(file);
        }
    }

    public onFileCancelled(): void {
        this.clearSelectedImage();
    }

    public onClearImage(): void {
        this.clearImageFileInput();
        this.clearSelectedImage();
    }

    private clearSelectedImage() {
        this.setEmptyImgSrc('selected-image');
        this.image = null;
    }

    private clearImageFileInput() {
        this.setEmptyFileInputValue('image-file-input');
    }

    public onDeleteConfirm = async () => {
        this.showModal = false;
        this.openConfirmDialog(
            undefined,
            () => this.deleteItem(this.item.id),
            () => this.onCancel()
        );
    };

    public onCancel() {
        this.showModal = true;
    }

    public deleteItem(itemIdToDeleteId: number): void {
        this.handleSpinner(
            firstValueFrom(this.coreService.deleteLanguage(itemIdToDeleteId))
                .then(res => {
                    this.bsModalRef.hide();
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err);
                })
        );
    }

    public onSave = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            if (!this.item && this.image == null) {
                this.translatedToastrService.warning('common.image_is_required', 'common.warning');
                return;
            }

            let language: LanguageEditModel = <LanguageEditModel>this.form.getRawValue();
            language.id = this.item?.id;

            let itemToSave: LanguageSaveModel = {
                language: language,
                flagImage: <any>this.image,
            };

            return this.handleSpinner(
                firstValueFrom(this.coreService.updateLanguage(itemToSave))
                    .then(res => {
                        this.onClose(this.bsModalRef, 'save_success');
                        return Promise.resolve(res);
                    })
                    .catch((error: any) => {
                        this.validationHandlerService.handleServerError(error, this.form);
                    })
            );
        }
    };
}
